const animateCounter = (obj, start, end, duration) => {
  let startTimestamp = null
  const step = (timestamp) => {
    if (!startTimestamp) startTimestamp = timestamp
    const progress = Math.min((timestamp - startTimestamp) / duration, 1)
    obj.innerHTML = Math.floor(progress * (end - start) + start)

    if (progress < 1) {
      window.requestAnimationFrame(step)
    }
  }
  window.requestAnimationFrame(step)
}

const initCounters = function initCounters()
{
  const counters = document.querySelectorAll('.counter');

  if( counters.length ) {
    counters.forEach( item => {

      if(!!window.IntersectionObserver){
        var observer = new IntersectionObserver((entries) => { 
          entries.forEach(entry => {
            if(entry.isIntersecting){	
              if( item.classList.contains('was-animated') ) return false;

              item.classList.add('was-animated');

              const counterItems = item.querySelectorAll('.counter__number');

              if( counterItems.length ) {
                counterItems.forEach( number => {      
                  animateCounter( number, 0, Number(number.innerHTML), 2000 );
                })
              }              
            }
          });
        }, {threshold: 0.75});
      
        observer.observe(item);
      } 
    });
  }
}
export { initCounters };